import { Form, DatePicker, Input } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import CountryPhoneInput from '@root/core/components/CountryPhoneInput';
import { orderReturn } from '@root/state/reducers/return_disposal/returnDisposalReducer';
import moment from 'moment';

function OrderForm({
  edit,
  orderForm
}: {
  edit?: boolean;
  orderForm: orderReturn;
}) {
  const isEdit = edit ? true : false;

  const [form] = Form.useForm();
  const dateFormat = 'YYYY-MM-DD';

  const [countryCode, setCountryCode] = useState<string>('+1');

  const defaultValue = useMemo(() => {
    return {
      orderNumber: orderForm ? orderForm?.orderNumber : '',
      orderDate: orderForm ? moment(orderForm?.orderDate) : '',
      saleChannel: orderForm ? orderForm?.saleChannel : '',
      buyerName: orderForm ? orderForm?.buyerName : '',
      buyerEmail: orderForm ? orderForm?.buyerEmail : '',
      recipientName: orderForm ? orderForm?.recipientName : '',
      shippingAddress: orderForm ? orderForm?.shippingAddress : '',
      detailAddress: orderForm ? orderForm?.detailAddress : '',
      detailAddress2: orderForm ? orderForm?.detailAddress2 : '',
      recipientPhone: orderForm ? orderForm?.recipientPhone : '',
      recipientCountryCode: orderForm ? orderForm?.recipientCountryCode : '',
      street: orderForm ? orderForm?.street : '',
      city: orderForm ? orderForm?.city : '',
      state: orderForm ? orderForm?.state : '',
      postalCode: orderForm ? orderForm?.postalCode : '',
      country: orderForm ? orderForm?.country : ''
    };
  }, [orderForm]);
  useEffect(() => {
    form.setFieldsValue(defaultValue);
  }, [form, defaultValue]);
  return (
    <>
      <Form
        form={form}
        name="complex-form"
        style={{
          marginBottom: '30px'
        }}
        initialValues={{
          orderNumber: defaultValue.orderNumber,
          orderDate: defaultValue.orderDate,
          saleChannel: defaultValue.saleChannel,
          buyerName: defaultValue.buyerName,
          buyerEmail: defaultValue.buyerEmail,
          recipientName: defaultValue.recipientName,
          shippingAddress: defaultValue.shippingAddress,
          detailAddress: defaultValue.detailAddress,
          detailAddress2: defaultValue.detailAddress2,
          recipientPhone: defaultValue.recipientPhone,
          street: defaultValue.street,
          city: defaultValue.city,
          state: defaultValue.state,
          postalCode: defaultValue.postalCode,
          country: defaultValue.country
        }}
      >
        <Form.Item style={{ marginBottom: '20px' }}>
          <Form.Item
            label="Order Number"
            name="orderNumber"
            style={{
              display: 'inline-block',
              width: '30%',
              marginRight: '30px',
              borderRadius: '10px'
            }}
          >
            <Input className="inputRadious" disabled={isEdit} />
          </Form.Item>
          <Form.Item
            label="Order Date"
            name="orderDate"
            style={{
              display: 'inline-block',
              width: '30%',
              marginRight: '30px'
            }}
          >
            <DatePicker
              style={{ width: '100%' }}
              className="inputRadious"
              format={dateFormat}
              disabled={isEdit}
            />
          </Form.Item>
          <Form.Item
            label="Online Website"
            name="saleChannel"
            style={{ display: 'inline-block', width: '30%' }}
          >
            <Input className="inputRadious" disabled={isEdit} />
          </Form.Item>
        </Form.Item>
        <Form.Item style={{ marginBottom: '20px' }}>
          <Form.Item
            label="Buyer Name"
            name="buyerName"
            style={{
              display: 'inline-block',
              width: '30%',
              marginRight: '30px'
            }}
          >
            <Input className="inputRadious" disabled={isEdit} />
          </Form.Item>
          <Form.Item
            label="Buyer Email"
            name="buyerEmail"
            style={{
              display: 'inline-block',
              width: '30%',
              marginRight: '30px'
            }}
          >
            <Input className="inputRadious" disabled={isEdit} />
          </Form.Item>
        </Form.Item>
        <Form.Item style={{ marginBottom: '20px' }}>
          <Form.Item
            label="Recipient Name"
            name="recipientName"
            style={{
              display: 'inline-block',
              width: '30%',
              marginRight: '30px'
            }}
          >
            <Input className="inputRadious" disabled={isEdit} />
          </Form.Item>
          <Form.Item
            label="Shipping Country/Address"
            name="country"
            style={{
              display: 'inline-block',
              width: '20%',
              marginRight: '30px'
            }}
          >
            <Input className="inputRadious" disabled={isEdit} />
          </Form.Item>
          <Form.Item
            label=""
            name="detailAddress"
            style={{
              display: 'inline-block',
              width: 'calc(50% - 60px)',
              marginTop: '32px'
            }}
          >
            <Input className="inputRadious" disabled={isEdit} />
          </Form.Item>
        </Form.Item>
        <Form.Item style={{ marginBottom: '20px' }}>
          <Form.Item
            label="Recipient Phone Number"
            name="recipientCountryCode"
            style={{
              display: 'inline-block',
              width: '30%',
              marginRight: '30px'
            }}
          >
            <CountryPhoneInput
              defaultCode={defaultValue?.recipientCountryCode}
              disabled={isEdit}
              placeholder="Please enter number only"
              title=""
              name="recipientPhone"
              onchange={(value) => {
                setCountryCode(value);
              }}
              phoneNumberRules={[
                {
                  required: true,
                  message: 'Phone number is required'
                }
              ]}
            />
          </Form.Item>
          <Form.Item
            style={{
              display: 'inline-block',
              width: 'calc(70% - 30px)',
              marginTop: '-10px'
            }}
          >
            <Form.Item
              name="detailAddress2"
              style={{
                display: 'inline-block',
                width: '50%',
                paddingRight: '15px'
              }}
            >
              <Input className="inputRadious" disabled={isEdit} />
            </Form.Item>
            <Form.Item
              name="detailAddress"
              style={{
                display: 'inline-block',
                width: 'calc(50%)',
              }}
            >
              <Input className="inputRadious" disabled={isEdit} />
            </Form.Item>
            <Form.Item
              name="city"
              style={{
                display: 'inline-block',
                width: '33%',
                paddingRight: '15px',
                marginTop: '10px',
              }}
            >
              <Input className="inputRadious" disabled={isEdit} />
            </Form.Item>
            <Form.Item
              name="state"
              style={{
                display: 'inline-block',
                width: '34%',
                paddingRight: '15px',
                marginTop: '10px',
              }}
            >
              <Input className="inputRadious" disabled={isEdit} />
            </Form.Item>
            <Form.Item
              name="postalCode"
              style={{
                display: 'inline-block',
                width: '33%',
                marginTop: '10px',
              }}
            >
              <Input className="inputRadious" disabled={isEdit} />
            </Form.Item>
          </Form.Item>
        </Form.Item>
      </Form>
    </>
  );
}

export default OrderForm;
